<span><mat-icon [ngClass]="outlined ? 'material-icons-outlined' : 'material-icons' ">{{iconName}}</mat-icon>
  {{fallbackLabel}}</span>
